var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { APP_MODE } from "@travel/shared/types";
import { getAnalytics } from "../analytics";
var TravelError = /** @class */ (function (_super) {
    __extends(TravelError, _super);
    function TravelError(_a) {
        var source = _a.source, message = _a.message, code = _a.code, status = _a.status, info = _a.info, url = _a.url, stack = _a.stack, request = _a.request, input = _a.input, partnerID = _a.partnerID, token = _a.token;
        var _this = _super.call(this, message) || this;
        _this.source = "";
        _this.code = "";
        _this.status = "";
        _this.name = TravelError.name;
        _this.source = source || _this.source;
        _this.code = code || _this.code;
        _this.status = status || _this.status;
        _this.info = info;
        _this.stack = stack;
        _this.request = request;
        _this.input = input;
        _this.url = url;
        _this.token = token;
        if (typeof window !== "undefined") {
            getAnalytics().then(function (_a) {
                var _b = __read(_a, 1), analytics = _b[0];
                return analytics.track("".concat(_this.code || APP_MODE, ":error"), {
                    partnerID: partnerID,
                    source: _this.source,
                    code: _this.code,
                    message: _this.message,
                    url: _this.url,
                    request: request,
                });
            });
        }
        console.error(_this);
        return _this;
    }
    return TravelError;
}(Error));
export { TravelError };
